import { combineReducers } from "redux";
import { _FAILURE, _SUCCESS, CREATE_DOCTOR_REQUEST, FETCH_DOCTORS_REQUEST } from "./constants";
import { CHANGE_DOCTOR_STATUS_REQUEST, CHANGE_DOCTOR_WEIGHT_REQUEST } from "../doctor/constants";
import { Doctor } from "../types";
import { Action } from "./types";
import { Action as DoctorAction } from "../doctor/types";

function items(state: Doctor[] = [], action: Action | DoctorAction): Doctor[] {
  switch (action.type) {
    case FETCH_DOCTORS_REQUEST + _SUCCESS:
      return action.payload.data;

    case CREATE_DOCTOR_REQUEST + _SUCCESS:
      return [...state, action.payload];

    case CHANGE_DOCTOR_STATUS_REQUEST:
    case CHANGE_DOCTOR_WEIGHT_REQUEST:
      return state.map((doctor) =>
        doctor.id === action.data.doctorId ? { ...doctor, isFetching: true } : doctor
      );

    case CHANGE_DOCTOR_STATUS_REQUEST + _SUCCESS:
    case CHANGE_DOCTOR_WEIGHT_REQUEST + _SUCCESS:
      return state.map((doctor) =>
        doctor.id === action.data.doctorId ? { ...action.payload, isFetching: false } : doctor
      );

    case CHANGE_DOCTOR_STATUS_REQUEST + _FAILURE:
    case CHANGE_DOCTOR_WEIGHT_REQUEST + _FAILURE:
      return state.map((doctor) =>
        doctor.id === action.data.doctorId ? { ...doctor, isFetching: false } : doctor
      );

    default:
      return state;
  }
}

function pageCount(state: number = 0, action: Action): number {
  switch (action.type) {
    case FETCH_DOCTORS_REQUEST + _SUCCESS:
      return action.payload.pageCount;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_DOCTORS_REQUEST:
      return true;
    case FETCH_DOCTORS_REQUEST + _SUCCESS:
    case FETCH_DOCTORS_REQUEST + _FAILURE:
      return false;
    default:
      return state;
  }
}

export const doctors = combineReducers({ items, pageCount, isFetching });
